module.exports = __webpack_public_path__ + "static/media/staff-illustration--cropped@1x.54b19516.png";